import SheetAssistant from '../Components/Spreadsheet/SheetAssistant/SheetAssistant';
import SheetStats from '../Components/Spreadsheet/SheetInfo/SheetInfoPanel';
import RowDetailPanel from '../Components/TableGrid/rowDetail/rowDetailPanel';
import {
  SIDE_PANEL_ASSISTANT_PANEL,
  SIDE_PANEL_COLUMN_PANEL,
  SIDE_PANEL_ROWS_PANEL,
  SIDE_PANEL_INFO_PANEL,
} from '../Utils/constants';

export const sidebar = {
  toolPanels: [
    {
      id: SIDE_PANEL_ASSISTANT_PANEL,
      labelDefault: '',
      labelKey: 'sheetAssistant',
      iconKey: 'sheetAssistantIcon',
      toolPanel: SheetAssistant,
    },
    {
      id: SIDE_PANEL_COLUMN_PANEL,
      labelDefault: '',
      labelKey: 'columns',
      iconKey: 'columnsIcon',
      toolPanel: 'agColumnsToolPanel',
    },
    {
      id: SIDE_PANEL_ROWS_PANEL,
      labelDefault: '',
      labelKey: 'rows',
      iconKey: 'rows',
      toolPanel: RowDetailPanel,
    },
    {
      id: SIDE_PANEL_INFO_PANEL,
      labelDefault: '',
      labelKey: 'stats',
      iconKey: 'statsIcon',
      toolPanel: SheetStats,
    },
  ],
  position: 'right',
  maxWidth: 600,
};
